module.exports = __webpack_public_path__ + "assets/img/00054.1240a10d.png";